export default function () {
    return {
        passengers: []

    }
}


